export const services = [
  {
    title: "Sports Physiotherapy",
    description: "Specialized treatment for sports-related injuries and performance enhancement.",
    image: "/sports.png",
    longDescription: "Our sports physiotherapy service is designed to help athletes and active individuals recover from injuries, improve performance, and prevent future problems. We use evidence-based techniques and advanced treatment methods to get you back to your sport quickly and safely.",
    benefits: [
      "Faster recovery from sports injuries",
      "Improved athletic performance",
      "Injury prevention strategies",
      "Sport-specific rehabilitation programs",
      "Performance enhancement techniques"
    ],
    process: "We begin with a thorough assessment of your condition and sporting requirements. Our treatment plan may include manual therapy, exercise prescription, taping, and rehabilitation programs specifically designed for your sport.",
    features: [
      "Comprehensive injury assessment",
      "Sport-specific rehabilitation",
      "Performance optimization",
      "Injury prevention strategies"
    ]
  },
  {
    title: "Orthopedic Physiotherapy",
    description: "Specialized treatment for musculoskeletal conditions and post-surgical rehabilitation.",
    image: "/ortho.png",
    gradient: "linear-gradient(45deg, #2B6CB0, #4299E1)",
    features: [
      "Joint and muscle rehabilitation",
      "Post-surgery recovery",
      "Pain management",
      "Movement analysis"
    ]
  },
  {
    title: "Manual Therapy",
    description: "Hands-on techniques to reduce pain and improve mobility in joints and soft tissues.",
    image: "/Manual Therapy.png",
    gradient: "linear-gradient(45deg, #38A169, #48BB78)",
    features: [
      "Joint mobilization",
      "Soft tissue manipulation",
      "Pain relief techniques",
      "Range of motion improvement"
    ]
  },
  {
    title: "Cardiac Rehabilitation",
    description: "Comprehensive programs to support heart health and recovery after cardiac events.",
    image: "/Cardiac.png",
    gradient: "linear-gradient(45deg, #E53E3E, #FC8181)",
    features: [
      "Cardiac exercise programs",
      "Heart health monitoring",
      "Lifestyle modification",
      "Risk factor management"
    ]
  },
  {
    title: "Women's Health",
    description: "Specialized physiotherapy services addressing women's unique health needs throughout all life stages.",
    image: "/womenhealth.png",
    gradient: "linear-gradient(45deg, #D53F8C, #F687B3)",
    features: [
      "Pregnancy care",
      "Postpartum recovery",
      "Pelvic health",
      "Osteoporosis management"
    ]
  },
  {
    title: "Vestibular Rehabilitation",
    description: "Treatment for dizziness, vertigo, and balance disorders using specialized techniques.",
    image: "/Vestibular rehabilitation.png",
    gradient: "linear-gradient(45deg, #805AD5, #B794F4)",
    features: [
      "Balance training",
      "Vertigo treatment",
      "Gaze stabilization",
      "Fall prevention"
    ]
  },
  {
    title: "Home Care Services",
    description: "Professional physiotherapy care delivered in the comfort of your home.",
    image: "/homecare.png",
    gradient: "linear-gradient(45deg, #319795, #4FD1C5)",
    features: [
      "In-home assessment",
      "Personalized treatment",
      "Environmental modification",
      "Caregiver education"
    ]
  },
  {
    title: "Geriatric Physiotherapy",
    description: "Specialized care for elderly patients focusing on mobility, balance, and independence.",
    image: "/geriatric.png",
    gradient: "linear-gradient(45deg, #744210, #975A16)",
    features: [
      "Balance improvement",
      "Fall prevention",
      "Strength training",
      "Mobility enhancement"
    ]
  },
  {
    title: "Neurological Rehabilitation",
    description: "Expert care for patients with neurological conditions to improve function and quality of life.",
    image: "/neuro.png",
    gradient: "linear-gradient(45deg, #285E61, #319795)",
    features: [
      "Stroke rehabilitation",
      "Movement retraining",
      "Functional improvement",
      "Cognitive strategies"
    ]
  }
]; 